import { render, staticRenderFns } from "./RenderMenuApps.vue?vue&type=template&id=fad732bc"
import script from "./RenderMenuApps.vue?vue&type=script&lang=js"
export * from "./RenderMenuApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports